function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.18274 12.0911C3.06438 12.0207 2.92222 12.0022 2.78981 12.04L0.228011 12.772L0.959954 10.2102C0.997786 10.0778 0.979331 9.93562 0.908942 9.81726C0.316941 8.82178 0 7.6847 0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C5.3153 13 4.17821 12.6831 3.18274 12.0911ZM14 6.5C14 6.15018 13.9761 5.80595 13.9297 5.46886C16.35 6.44299 18 8.80865 18 11.5C18 12.6847 17.6831 13.8218 17.0911 14.8173C17.0207 14.9356 17.0022 15.0778 17.04 15.2102L17.772 17.772L15.2102 17.04C15.0778 17.0022 14.9356 17.0207 14.8173 17.0911C13.8218 17.6831 12.6847 18 11.5 18C8.81102 18 6.44419 16.3526 5.4689 13.9296C5.80798 13.9763 6.15229 14 6.5 14C10.6421 14 14 10.6421 14 6.5Z",
  fill: "white"
});

function SvgChatActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/chat-active.49b6b524.svg";
export { ForwardRef as ReactComponent };